export default __webpack_public_path__ + "static/media/zonaet-hossain-resume-for-Frontend-developer.6b11cc85.pdf";